import styled from 'styled-components';

export const CardCE = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 290px;
  height: 100%;
`;
